import axios from './axios';
import SETTINGS from '../settings'
export default {
    getIdeas(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/post`, {
            params: params
        }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    addReaction(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/usercontentreaction`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    },
    addIdea(payload, cb, errorCb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/post`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            errorCb(e)
        })
    },
    editIdea(payload, cb) {
        axios.put(`${SETTINGS.API_BASE_PATH}/post`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    }
}